import { FulfillmentStatus, FulfillmentType } from '@/cowboy/EnumTypes'

export const ItemFulfillmentMixin = {
  computed: {
    $itemFulfillmentMixin_fulfillmentTypeLabelMap () {
      return {
        [FulfillmentType.DIGITAL]: this.$t('checkout-digital-fulfillment'),
        [FulfillmentType.PHYSICAL]: this.$t('checkout-physical-fulfillment')
      }
    },
    $itemFulfillmentMixin_fulfillmentStatusLabelMap () {
      return {
        [FulfillmentStatus.COMPLETE]: this.$t('fulfillment-status.COMPLETE'),
        [FulfillmentStatus.PENDING]: this.$t('fulfillment-status.PENDING'),
        [FulfillmentStatus.FAILED]: this.$t('fulfillment-status.UNSUCCESSFUL')
      }
    },
    $itemFulfillmentMixin_fulfillmentStatusColorMap () {
      return {
        [FulfillmentStatus.COMPLETE]: 'success darken-1',
        [FulfillmentStatus.PENDING]: 'yellow darken-1',
        [FulfillmentStatus.FAILED]: 'error darken-1'
      }
    }
  }
}
